import React from 'react';
import { Card as StyledCard } from './Card.styled';

export interface CardProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
}

export function Card({ children, onClick, className }: CardProps) {
  return (
    <StyledCard onClick={onClick} className={className}>
      {children}
    </StyledCard>
  );
}
